import { hotEvents, type Category } from "@/mocks/events";
import SectionHeading from "./SectionHeading";

const CHANNELS: { name: Category; icon: string; img: string; desc: string }[] = [
  {
    name: "娱乐热点",
    icon: "ri-movie-2-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20film%20clapperboard%20and%20theater%20spotlights%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-01&orientation=landscape",
    desc: "明星动态、剧集综艺里的舆论起伏",
  },
  {
    name: "科技互联网",
    icon: "ri-smartphone-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20smartphone%20and%20digital%20circuit%20and%20cloud%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-02&orientation=landscape",
    desc: "App 争议、大厂动态、隐私与功能风波",
  },
  {
    name: "商业财经",
    icon: "ri-line-chart-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20rising%20bar%20chart%20and%20retail%20storefront%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-03&orientation=landscape",
    desc: "品牌联名、定价争议、消费热点观察",
  },
  {
    name: "社会民生",
    icon: "ri-home-smile-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20community%20street%20with%20houses%20and%20trees%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-04&orientation=landscape",
    desc: "景区、团购、基层服务里的讨论焦点",
  },
  {
    name: "直播电商",
    icon: "ri-shopping-cart-2-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20live%20streaming%20setup%20with%20ring%20light%20and%20shopping%20cart%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-05&orientation=landscape",
    desc: "主播选品、橱窗带货与售后维权",
  },
  {
    name: "文化综艺",
    icon: "ri-radio-2-line",
    img: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20retro%20television%20and%20stage%20curtains%2C%20warm%20cream%20paper%20background%2C%20vermilion%20coral%20and%20amber%20gold%20palette%2C%20minimal%20soft%20shapes%2C%20clean%20modern%20magazine%20art&width=800&height=520&seq=channel-06&orientation=landscape",
    desc: "综艺现场、栏目字幕与口碑争议",
  },
];

interface ChannelsProps {
  onSelect: (name: Category) => void;
}

export default function Channels({ onSelect }: ChannelsProps) {
  return (
    <section id="channels" className="border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="分类频道"
          title="按领域吃瓜，追得更省力"
          description="每个频道都是一条垂直内容线索：进入频道可快速筛选该领域下的热点事件，点击下方事件卡片还能直接展开完整时间线。"
        />

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {CHANNELS.map((c) => {
            const count = hotEvents.filter((e) => e.category === c.name).length;
            return (
              <button
                key={c.name}
                type="button"
                onClick={() => onSelect(c.name)}
                className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 text-left transition-all hover:-translate-y-0.5 hover:border-primary-200"
                aria-label={`进入 ${c.name} 频道`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={c.img}
                    alt={`${c.name} 频道插图`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2 top-2 rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-foreground-700">
                    {count} 起
                  </span>
                </div>
                <div className="p-3">
                  <div className="flex items-center gap-1.5 text-sm font-semibold text-foreground-900">
                    <i className={`${c.icon} text-primary-600`} />
                    {c.name}
                  </div>
                  <p className="mt-1.5 hidden text-[11px] leading-snug text-foreground-500 md:block lg:text-xs">
                    {c.desc}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}